export default "https://cdn-static.gokick.com/assets/09fae944e838c54f14fd77486c4f90b3472cb396/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";